import { createSelector } from '@ngrx/store';
import { selectNavigationState } from './navigation.selectors';

export const selectDirtyState = createSelector(selectNavigationState, state => state.dirtyState);

export const selectIsDirty = createSelector(selectDirtyState, dirtyKeys => dirtyKeys.length > 0);

export const selectIsKeyDirty = (key: string) => createSelector(selectDirtyState, dirtyKeys => dirtyKeys.includes(key));
